export const baseAPI = '/api/payment-hub/payment'
